// --------------------------------------------------------
// GENELRAL IMPORTS
// --------------------------------------------------------
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
// --------------------------------------------------------
// PAGE IMPORTS
// --------------------------------------------------------
import LoginFields from "./components/loginFields/LoginFields";

import Landing from "./pages/Landing";
// --------------------------------------------------------
// ROUTE ROUTES
// --------------------------------------------------------
import { Paths } from "./enums/Paths";
import CareLineList from "./pages/careLine/CareLineList";
import RegisterCareLine from "./pages/careLine/RegisterCareLine";
import CompanyList from "./pages/company/CompanyList";
import RegisterCompany from "./pages/company/companyRegister/CompanyRegister";
import OccupationalHealthList from "./pages/occupationalHealth/OccupationalHealthList";
import OccupationalHealthRegister from "./pages/occupationalHealth/OccupationalHealthRegister";
import UnitList from "./pages/unit/UnitList";
import UnitRegister from "./pages/unit/UnitRegister";
import UserRole from "./pages/userRoles/UserRoles";
import { AppStorage } from "./storage/AppStorage";

import ChangePassword from "./components/loginFields/ChangePassword";
import CollaboratorInitial from "./pages/collaboratorInitial/CollaboratorInitial";
import AgendaDia from "./pages/criarAgenda/AgendaDia";
import AppointmentPanel from "./pages/appointmentPanel/AppointmentPanel";
import AgendaList from "./pages/criarAgenda/AgendaList";
import AgendaMes from "./pages/criarAgenda/AgendasMes";
import AgendasProfissional from "./pages/criarAgenda/AgendasProfissional";
import CriarAgenda from "./pages/criarAgenda/CriarAgenda";
import AgendaPreviewDia from "./pages/criarAgenda/AgendaPreviewDia";
import ExamsPage from "./pages/exams/Exams";
import FileImport from "./pages/fileImport/FileImport";
import HMVQuestionnaire from "./pages/HMVQuestionnaire/HMVQuestionnaire";
import OMSQuestionnaire from "./pages/OMSQuestionnaire/OMSQuestionnaire";
import RelationshipGHE from "./pages/relationshipGHE/RelationshipGHE";
import DetailSchedulingPage from "./pages/Scheduling/DetailSchedulingPage";
import Scheduling from "./pages/Scheduling/Scheduling";
import PrivateRoute from "./PrivateRoute";
import MyPeriodics from "./pages/collaborator/periodics/MyPeriodics";
import MyCareline from "./pages/collaborator/careLine/MyCareline";
import InformationsCpt from "./pages/informationComplementary/InformationsCpt";
import MedicalRecord from "./pages/medicalRecord/MedicalRecord";
import HealthProfessionalPanel from "./pages/healthProfessionalPanel/HealthProfessionalPanel";
import DetailsAttendanceRecord from "./pages/medicalRecord/components/attendanceRecord/components/details/DetailsAttendanceRecord";
import AttachCareLine from "./pages/medicalRecord/components/careLines/AttachCareLine";
import CareLineOccupHealthDetail from "./pages/medicalRecord/components/careLines/CareLineOccupHealthDetail";
import RegisterExam from "./pages/medicalRecord/components/exams/RegisterExam";
import RegisterAllergy from "./pages/medicalRecord/components/allergies/RegisterAllergy";
import UserRoleEditProfile from "./pages/userRoleEditProfile/UserRoleEditProfile";
import MedicalRecordList from "./pages/medicalRecord/MedicalRecordList";
import MeusPacientes from "./pages/meusPacientes/MeusPacientes";
import PainelNavegacao from "./pages/painelNavegacao/PainelNavegacao";
import AcompanhamentoNavegacao from "./pages/acompanhamentoNavegacao/AcompanhamentoNavegacao";
import CallCenter from "./pages/callCenter/callCenter";
import ReaplicacaoQuestionario from "./pages/reaplicacaoQuestionario/ReaplicacaoQuestionario";
import VitalSignList from "./pages/vitalSign/VitalSignList";
import VitalSignRegister from "./pages/vitalSign/VitalSignRegister";

// --------------------------------------------------------
// COMPONENT
// --------------------------------------------------------
const AppRoutes = () => {
  // --------------------------------------------------------
  // REDUX
  // --------------------------------------------------------
  const { user, token, keepConnected, roles, currentProfile } = useSelector(
    (state: any) => state.login
  );
  // --------------------------------------------------------

  // STATES
  // --------------------------------------------------------
  const [accessToken, setAccessToken] = useState<string | undefined>(token);
  const [render, setRender] = useState<boolean>(false);
  // --------------------------------------------------------
  // FUNCTONS
  // --------------------------------------------------------
  const retrieveTokenOnCookie = async () => {
    const savedToken = await AppStorage.getAccessToken();
    setAccessToken(savedToken);
    // evita primeira renderização de login quando se tem o token
    setRender(true);
  };
  // --------------------------------------------------------
  // EFFECTS
  // --------------------------------------------------------
  useEffect(() => {
    retrieveTokenOnCookie();
  }, [token]);
  // --------------------------------------------------------
  // RENDER
  // --------------------------------------------------------
  /*Lista de Rotas da aplicação com seus respectivos componentes, URLs e proteções por usuário logado ou role */
  /* Rota de autenticação */
  const AuthRoutes = () => {
    return (
      <Routes>
        <Route index element={<LoginFields />} />
        <Route path={Paths.ChangePassword} element={<ChangePassword />} />
        <Route
          element={
            <PrivateRoute
              user={user}
              token={token}
              redirectPath="/"
              isAllowedByRole={!!accessToken}
            />
          }
        >
          <Route path={Paths.ChangePassword} element={<ChangePassword />} />
          <Route path="*" element={<></>} />
        </Route>
      </Routes>
    );
  };

  /* Rotas de Acesso, depois da autenticação */
  const AccessRoutes = () => {
    return (
      <Routes>
        <Route index element={<Landing />} />
        <Route path={Paths.ChangePassword} element={<ChangePassword />} />
        <Route
          path={Paths.InformationComplementary}
          element={<InformationsCpt />}
        />
        <Route path={Paths.OMSQuestionnaire} element={<OMSQuestionnaire />} />
        <Route path={Paths.HMVQuestionnaire} element={<HMVQuestionnaire />} />
        <Route
          path={Paths.CollaboratorInitial}
          element={<CollaboratorInitial />}
        />

        {/* Rotas que apenas o perfil ADM tem acesso */}
        <Route
          element={
            <PrivateRoute
              user={user}
              token={token}
              redirectPath="/"
              isAllowedByRole={
                !!accessToken && ["ADM"].includes(currentProfile)
              }
            />
          }
        >
          <Route path={Paths.CompanyList} element={<CompanyList />} />
          <Route path={Paths.RegisterCompany} element={<RegisterCompany />} />
          <Route path={Paths.UnitList} element={<UnitList />} />
          <Route path={Paths.RegisterUnit} element={<UnitRegister />} />

          <Route path={Paths.CareLineList} element={<CareLineList />} />
          <Route path={Paths.RegisterCareLine} element={<RegisterCareLine />} />
          <Route
            path={Paths.OccupationalHealthList}
            element={<OccupationalHealthList />}
          />
          <Route
            path={Paths.OccupationalHealthRegister}
            element={<OccupationalHealthRegister />}
          />
          <Route path={Paths.VitalSignList} element={<VitalSignList />} />
          <Route path={Paths.VitalSignRegister} element={<VitalSignRegister />} />
          <Route path={Paths.ReaplicacaoQuestionario} element={<ReaplicacaoQuestionario />} />
        </Route>

        {/* Rotas que apenas o perfil PACIENTE/COLABORADOR tem acesso */}
        <Route
          element={
            <PrivateRoute
              user={user}
              token={token}
              redirectPath="/"
              isAllowedByRole={
                !!accessToken && ["PAC"].includes(currentProfile)
              }
            />
          }
        >
          <Route path={Paths.exams} element={<ExamsPage />} />
          <Route path={Paths.MeusPeriodicos} element={<MyPeriodics />} />
          <Route path={Paths.MinhaLinhaCuidado} element={<MyCareline />} />
        </Route>

        <Route
          element={
            <PrivateRoute
              user={user}
              token={token}
              redirectPath="/"
              isAllowedByRole={
                !!accessToken &&
                ["MED", "ENF", "PSI", "TEE", "NUT"].includes(currentProfile)
              }
            />
          }
        >
          <Route
            path={Paths.PainelConsulta}
            element={<HealthProfessionalPanel />}
          />
          <Route path={Paths.RegistrarExame} element={<RegisterExam />} />
          <Route path={Paths.RegistrarAlergia} element={<RegisterAllergy />} />

          {/** Painel de Consultas e tudo o que vem dele entra aqui aqui RegistrarExame*/}
        </Route>

        <Route
          element={
            <PrivateRoute
              user={user}
              token={token}
              redirectPath="/"
              isAllowedByRole={
                !!accessToken && ["TEE", "REC", "ENF", "ADM"].includes(currentProfile)
              }
            />
          }
        >
          <Route
            path={Paths.PainelAtendimento}
            element={<AppointmentPanel />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute
              user={user}
              token={token}
              redirectPath="/"
              isAllowedByRole={
                !!accessToken && ["ADM", "ADE", "GES"].includes(currentProfile)
              }
            />
          }
        >
          <Route path={Paths.FileImport} element={<FileImport />} />
          <Route path={Paths.RelationshipGHE} element={<RelationshipGHE />} />
        </Route>
        <Route
          element={
            <PrivateRoute
              user={user}
              token={token}
              redirectPath="/"
              isAllowedByRole={
                !!accessToken && ["ENF", "REC", "ADM", "TEE"].includes(currentProfile)
              }
            />
          }
        >
          <Route path={Paths.AgendaList} element={<AgendaList />} />
          <Route path={Paths.CriarAgenda} element={<CriarAgenda />} />
          <Route path={Paths.AgendaPreviewDia} element={<AgendaPreviewDia />} />
          <Route path={Paths.Agendas} element={<AgendasProfissional />} />
          <Route path={Paths.AgendasMes} element={<AgendaMes />} />
          <Route path={Paths.AgendaDias} element={<AgendaDia />} />
        </Route>

        <Route
          element={
            <PrivateRoute
              user={user}
              token={token}
              redirectPath="/"
              isAllowedByRole={
                !!accessToken && ["ADM", "TEE"].includes(currentProfile)
              }
            />
          }
        >
          <Route path={Paths.Agendas} element={<AgendasProfissional />} />
          <Route path={Paths.AgendasMes} element={<AgendaMes />} />
          <Route path={Paths.AgendaDias} element={<AgendaDia />} />
          <Route
            path={Paths.PainelAtendimento}
            element={<AppointmentPanel />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute
              user={user}
              token={token}
              redirectPath="/"
              isAllowedByRole={
                !!accessToken && ["MED", "ADM"].includes(currentProfile)
              }
            />
          }
        >
          <Route path={Paths.UserRole} element={<UserRole />} />
          <Route
            path={Paths.UserRoleEditProfile}
            element={<UserRoleEditProfile />}
          />
        </Route>

        <Route
          element={
            <PrivateRoute
              user={user}
              token={token}
              redirectPath="/"
              isAllowedByRole={
                !!accessToken && ["MED"].includes(currentProfile)
              }
            />
          }
        >
          <Route path={Paths.MeusPacientes} element={<MeusPacientes />} />
        </Route>

        <Route
          element={
            <PrivateRoute
              user={user}
              token={token}
              redirectPath="/"
              isAllowedByRole={
                !!accessToken && ["MED", "ENF", "ADM"].includes(currentProfile)
              }
            />
          }
        >
          <Route path={Paths.PainelNavegacao} element={<PainelNavegacao />} />
          <Route path={Paths.AcompanhamentoNavegacao} element={<AcompanhamentoNavegacao />} />
        </Route>


        <Route path={Paths.Scheduling} element={<Scheduling />} />
        <Route
          path={Paths.DetailScheduling}
          element={<DetailSchedulingPage />}
        />
        <Route path="*" element={<Landing />} />
        <Route path={Paths.FileImport} element={<FileImport />} />
        <Route
          path={Paths.CollaboratorInitial}
          element={<CollaboratorInitial />}
        />
        <Route path={Paths.RelationshipGHE} element={<RelationshipGHE />} />
        <Route
          path={Paths.DetailScheduling}
          element={<DetailSchedulingPage />}
        />
        <Route path={Paths.MeusPeriodicos} element={<MyPeriodics />} />
        <Route path={Paths.MinhaLinhaCuidado} element={<MyCareline />} />
        <Route path={Paths.Prontuario} element={<MedicalRecord />} />
        <Route
          path={Paths.RegistroAtendimento}
          element={<DetailsAttendanceRecord />}
        />
        <Route path={Paths.AtribuirLinhaCuidado} element={<AttachCareLine />} />
        <Route
          path={Paths.DetalharLinhaCuidado}
          element={<CareLineOccupHealthDetail />}
        />
        <Route path={Paths.ProntuarioPaciente} element={<MedicalRecordList />} />
        <Route path={Paths.CentralAgendamento} element={<CallCenter />} />
        {/* 
            Ajustar esse ponto quando tivermos definições sobre o login. Essas serão as rotas protegidas pelo token 
            <Route element={<PrivateRoute user={user} token={token} isAllowedByRole={!!accessToken} />}>
                <Route path={Paths.Home} element={<Home />} />
                <Route path={Paths.CompanyList} element={<CompanyList />} />
                <Route path={Paths.RegisterCompany} element={<RegisterCompany />} />
                <Route path={Paths.RegisterUnit} element={<UnitRegister />} />
            </Route>*/}
        {/*<Route element={<PrivateRoute 
                    user={user} 
                    token={token} 
                    redirectPath="/home" 
                    isAllowedByRole={!!accessToken && checkRolePermission(['admin', 'gestor'], roles)} />}> 
                <Route path="userLists" element={<ProtectedWithRole />} />
            </Route>*/}
      </Routes>
    );
  };

  const RenderComponent = () => {
    // Se houver token autenticado, renderizar as rotas de acesso. Caso contrário, renderizar rotas de autenticação
    return accessToken ? <AccessRoutes /> : <AuthRoutes />;
  };

  return <>{render && <RenderComponent />}</>;
};

export default AppRoutes;
